<template>
  <div class="carousel-wrapper" ref="slider">
    <div v-for="video in videos" :key="video.id" class="carousel-cell">
      <VideoCard :video="video" />
    </div>
  </div>
</template>

<script>
/**
 * This component is simply a presentational
 * component, once we have an idea of how
 * the DB will be we can make it reactive
 */
import VideoCard from "@/components/VideoCard.vue"
import Flickity from "flickity"
export default {
  props: {
    videos: {
      type: Array,
      required: true
    }
  },
  components: {
    VideoCard
  },
  data() {
    return {
      flick: null,
      flickityOptions: {
        cellAlign: "center",
        pageDots: false,
        groupCells: 4,
        arrowShape:
          "M0,50 L45,95 L54, 86 L26, 56.5 L100, 56.5 L100, 43.5 L26, 43.5 L54, 14 L45, 5 L0, 50 L60,100 Z"
      }
    }
  },
  beforeUpdate() {
    if (this.flick) {
      this.flick.destroy()
    }
  },
  updated() {
    this.flick = new Flickity(this.$refs.slider, this.flickityOptions)
  },
  mounted() {
    this.flick = new Flickity(this.$refs.slider, this.flickityOptions)
  }
}
</script>

<style src="flickity/dist/flickity.min.css"></style>
<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
/**
 * Flickity Overrides
 */
.flickity-button:disabled {
  pointer-events: all !important;
  z-index: 5;
}
.flickity-button.flickity-prev-next-button {
  top: 0;
  bottom: 0;
  margin: auto;
  transform: translateY(0);
  &,
  &:hover {
    background: $color-secondary !important;
    background: var(--color-secondary, $color-secondary) !important;
    box-shadow: 0px 0px 31px 3px rgba(0, 0, 0, 0.35);
  }

  &.previous {
    left: 30px;
  }

  &.next {
    right: 30px;
  }

  .flickity-button-icon {
    top: 32%;
    left: 32%;
    width: 36%;
    height: 36%;
    color: white;
  }
}

.carousel-cell {
  width: $carousel-cell-width;
  margin-right: 18px;
  .video-card,
  .video-card .video-thumbnail {
    // height: $thumbnail-height--carousel;
  }
}
</style>
